module.exports = __webpack_public_path__ + "img/60f9.fce47af6.jpg";